exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1GBD4{text-align:center;width:624px}._1mQt6{font-family:Roboto,sans-serif;margin-left:68px;margin-right:68px}._3IsFD{color:#fff;background-color:#e4002b;border-color:#e4002b;cursor:pointer;font-family:Roboto\\, Medium;width:140px}.z4zww{padding:15px 65px;display:block}.Y4H0M{text-transform:capitalize}", ""]);

// exports
exports.locals = {
	"modalContent": "_1GBD4",
	"modalBody": "_1mQt6",
	"boton_rojo": "_3IsFD",
	"modalFooter": "z4zww",
	"capitalize": "Y4H0M"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Telemedicina/ModalErrorDocumento/ModalErrorDocumento.css
// module id = 1255
// module chunks = 0 1